<style lang="scss" scoped>
.icon-lock:before {
  font-size: 24px;
}
.h-topbar-msgbox {
  .h-form-row {
    .h-form-item {
      padding-right: 8px;
      .h-input-wrapper {
        vertical-align: top;
      }
      .h-select {
        vertical-align: top;
      }
    }
  }
}
.lightblue {
  .h-topbar-logo {
    padding-right: 0px;
  }
  .h-topbar-logo-img {
    width: 192px;
  }
}
.h-topbar-tool {
  /deep/ .toolLast .h-select-dropdown {
    left: auto !important;
    right: 0;
    width: 320px !important;
  }
}
.topbar-user-image {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transform: translateY(10px);
}
</style>

<template>
  <div class="h-topbar">
    <div class="h-topbar-logo" v-if="!isWebType">
      <span class="h-topbar-logo-img" :style="logoStyle"></span>
    </div>
    <headerbar ref="headerbar" v-else></headerbar>
    <div class="h-topbar-nav">
      <template v-if="!isMergeMenu && menusRoot.length > 1">
        <div class="h-system-list">
          <div class="h-system-item" ref="systemItem">
            <h-menu theme="dark" :active-name="menuActive" mode="horizontal">
              <draggable v-model="menusRoot" @start="drag != true" @end="onEnd" :move="onMove">
                <h-menu-item :name="index" @click.native.prevent.stop="activeSidebar(index, item)" v-for="(item, index) in menusRoot"
                  :key="item.index" class="h-topbar-subMenu">{{ item.title }}</h-menu-item>
              </draggable>
            </h-menu>
          </div>
        </div>
        <div class="h-system-more-sort" @mouseleave="hideSystemList" v-show="systemHeight > 60">
          <div class="h-system-more" @click="showSystemList">
            <h-icon name="xf-more" size="24" v-show="systemHeight > 60"></h-icon>
          </div>
          <transition name="slide-up">
            <div class="h-system-sort-list" v-show="showSystem && systemHeight > 60">
              <ul>
                <draggable v-model="menusRoot" @start="drag = true" @end="onEnd" :move="onMove">
                  <h-menu-item :name="index" v-for="(item, index) in menusRoot" v-if="index >= showSysLen" :key="item.name"
                    @click.native.prevent.stop="activeSidebar(index, item)">
                    <span class="h-system-title" @mouseenter="showDragColl(index)" @mouseleave="hideDragColl">
                      <b>{{ item.title }}</b>
                      <h-icon name="xf-move" class="h-drag-icon" v-show="index == dragItemIndex"></h-icon>
                    </span>
                  </h-menu-item>
                </draggable>
              </ul>
            </div>
          </transition>
        </div>
      </template>
    </div>

    <div class="h-topbar-tool">
      <!--顶部菜单数据-->
      <h-menu theme="dark" mode="horizontal">
        <h-menu-item name="3" v-if="isShowLocalLang && localLangs.length > 0">
          <h-dropdown @on-click="changeLocale">
            <h-icon name="earth" class="lang-icon"></h-icon>
            <h-dropdown-menu slot="list">
              <h-dropdown-item v-for="(item, index) in systemLangs" :key="index" :name="item.lang" :selected="$i18n.locale === item.lang">
                {{ item.name }}</h-dropdown-item>
            </h-dropdown-menu>
          </h-dropdown>
        </h-menu-item>
        <!-- 分割线 -->
        <h-menu-item name="6" style="z-index: 10" class="toolSplit">
          <span class="h-topbar-split"></span>
        </h-menu-item>
        <!-- 下拉面板 -->
        <h-submenu name="7" class="toolLast">
          <template slot="title">
            <img v-if="userImage" class="topbar-user-image" :src="userImage" />
            <h-icon v-else name="xf-user-L" size="24" color="#9BABBF;"></h-icon>
            <span class="nick-name">{{ nickName }}</span>
          </template>
          <!--基本信息-->
          <h-menu-item name="7-5">
            <div class="h-topbar-tool-personal">
              <h-row class="h-topbar-tool-personalInfo">
                <h-col span="6">
                  <!--头像-->
                  <div class="h-topbar-tool-personalInfo-pic">
                    <img v-if="userImage" class="topbar-user-image" style="width:68px;height:68px" :src="userImage" />
                    <h-icon v-else name="xf-user-L" size="68" color="#9BABBF"></h-icon>
                  </div>
                </h-col>
                <h-col span="18">
                  <!--右边个人信息-->
                  <div class="h-topbar-tool-personalInfo-view">
                    <span class="h-info-user">{{ nickName
                      }}<span v-if="
                          currTenantId != null &&
                          currTenantId != '' &&
                          currTenantId != 'null'
                        ">{{ "(" + currTenantName + ")" }}</span></span>
                    <span class="h-info-org">{{ orgName }}</span>
                    <span v-if="lastLoginDateTime !== ''" class="h-info-time">{{
                      $t("m.i.common.lastLoginTime") + lastLoginDateTime
                    }}</span>
                    <span class="h-info-time">{{
                      $t("m.i.common.curVersion") + version
                    }}</span>
                  </div>
                </h-col>
              </h-row>
            </div>
          </h-menu-item>
          <!--修改个人信息-->
          <h-menu-item name="7-1" class="h-top-perOpt" @click.native="handleChangePersonInfo">
            <h-icon name="u-a-user"></h-icon>
            <span>账户中心</span>
          </h-menu-item>
          <!--修改密码-->
          <!-- <h-menu-item name="7-2" class="h-top-perOpt" v-if="!freeLogin" @click.native="handleResetPass">
            <h-icon name="u-a-key"></h-icon>
            <span>密码管理</span>
          </h-menu-item> -->
          <!--注销登录-->
          <h-menu-item v-if="loginOff" name="7-4" class="h-top-perOpt" @click.native="logoff">
            <h-icon name="u-a-export"></h-icon>
            <span>注销登录</span>
          </h-menu-item>
          <!--退出登录-->
          <h-menu-item v-if="!freeLogin" name="7-4" class="h-top-perOpt" @click.native="logout">
            <h-icon name="u-a-export"></h-icon>
            <span>退出系统</span>
          </h-menu-item>
        </h-submenu>
      </h-menu>
    </div>

    <h-msg-box v-model="comfirmBox" :title="$t('m.i.common.hint')" @on-ok="ok" @on-cancel="cancel" class="h-topbar-msgbox">
      <p>{{ comfirmMsg }}</p>
    </h-msg-box>
    <!-- 检测更新 -->
    <h-msg-box v-model="showProgressInfo" :title='updateTitle' :closable="false" :mask-closable="false" width="300" class="h-topbar-msgbox">
      <div v-bind:style="{display:displayStateOne}">
        <p style="margin-top:-19px">{{showInfo}}</p>
      </div>
      <div v-bind:style="{display:displayStateTwo}">
        <p style="margin-top:-19px;white-space:pre-line;">{{showInfo}}</p>
        <h-progress v-bind:style="{display:displayStateThree}" :percent='updatePercent'></h-progress>
      </div>
      <!-- 无更新版本时显示 -->
      <div slot="footer" v-bind:style="{display:displayStateOne}">
        <h-button type="ghost" style="margin:0 8px" @click="closeUpdate()">关闭</h-button>
      </div>
      <!-- 有更新版本时显示 -->
      <div slot="footer" v-bind:style="{display:displayStateFive}">
        <h-button :disabled='disable' type="primary" @click="startUpdate()">确认</h-button>
        <h-button :disabled='disable' v-if="closable" @click="closeUpdate()">取消</h-button>
      </div>
      <!-- 更新完重启显示 -->
      <div slot="footer" v-bind:style="{display:displayStateFour}">
        <h-button type="ghost" style="margin:0 8px" @click="logout(1)">立即重启</h-button>
      </div>
    </h-msg-box>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import {
  checkDefPwd,
  checkPwdExpired,
  expiredDays,
  getCurrUserInfo,
  getPwdCheckStandard,
  getSystemParm,
} from '@frame/api/login'
import { allToggleClass } from '@common/utils/tools'
import { covertObj, on, off } from '@common/utils/commonUtil'
import draggable from 'vuedraggable'
import HSearchselect from '@frame/components/searchselect/HSearchSelect.vue'
import LockScreen from '@frame/components/LockScreen'
import Cookies from 'js-cookie'
import { getAuthority, sendPhoneCode } from '@uc/api/safeCenter/index'
import { getExtSysConfig, getHeadImg } from '@frame/api/common/index'
import {
  encrypt,
  fTime,
  pwdPassVlitor,
  payPwdPassVlitor,
} from '@frame/utils/Utils'
import store from '@common/entry/store'
import { unlockLogin } from '@frame/api/login/index'
import cloneDeep from 'clone-deep'
import Headerbar from './Headerbar'
export default {
  data () {
    let userMap = this.$getCurrInfo()
    if (typeof userMap === 'undefined') {
      window.sessionStorage.removeItem('token')
      Cookies.remove('user_token')
      store.commit('SET_TOKEN', '')
      window.localStore.remove('token')
      window.localStore.remove('ucWsCurrUser')
      location.reload()
    } else {
      let userMap = window.sessionStorage.getItem('ucWsCurrUser')
      if (typeof userMap === 'undefined' || userMap === null) {
        let param = {
          ucWsCurrUser: window.localStore.get('ucWsCurrUser'),
          token: window.localStore.get('token'),
        }
        this.$store
          .dispatch('saveCurrInfo', param)
          .then((res) => { })
          .catch((e) => {
            console.error(e)
          })
      }
    }
    let main = userMap['parentId'] === '-1'
    let currUserId = window.sessionStorage.getItem('userId')
    let nickName = userMap['account'] // window.sessionStorage.getItem('nickName')// 操作员昵称
    let currTenantId = window.sessionStorage.getItem('tenantId') // 租户ID
    let currTenantName = window.sessionStorage.getItem('tenantName') // 租户名称
    let curSpaceId = window.sessionStorage.getItem('envId') // 空间ID
    let curSpaceName = window.sessionStorage.getItem('envName') // 空间名称
    let lastLoginDateTime = fTime(userMap['lastLoginTime']) // window.sessionStorage.getItem('lastLoginDateTime') || '--'// 最近登录时间
    let orgName = window.sessionStorage.getItem('orgName')
    let version = window.LOCAL_CONFIG.VERSION + '' // 版本信息

    return {
      menuActive: 0,
      isMain: main,
      langs: [
        { lang: 'zh-CN', name: '简体中文' },
        { lang: 'zh-TW', name: '繁体中文' },
        { lang: 'en-US', name: 'English' },
      ],
      // 系统名
      sysName: window.LOCAL_CONFIG.SYS_NAME,
      currUserId: currUserId,
      nickName: nickName,
      currTenantId: currTenantId,
      currTenantName: currTenantName,
      orgName: orgName,
      lastLoginDateTime: lastLoginDateTime,
      version: version,
      closable: true,
      comfirmBox: false,
      comfirmMsg: '',
      msgInfo: this.$t('m.i.common.defaultPwdMsg'),
      validNewPassCheck: [{ test: pwdPassVlitor, trigger: 'blur' }],
      locktime: 100, // 锁屏时间,默认100分钟
      theme: Cookies.get('theme')
        ? Cookies.get('theme')
        : this.LOCAL_CONFIG.THEME,
      tipState: null,
      isMergeMenu: false,
      isOpenFirstPwd: false,
      isHidePwdAndLockScreen: false,
      freeLogin: false,
      loginOff: window.isElectron,
      isShowTenant: false,
      isShowLocalLang: false,
      isShowTheme: true,
      subSystem: [],
      changePerspnInfo: false,
      showProgressInfo: false,
      displayStateOne: 'none',
      displayStateTwo: 'none',
      displayStateThree: 'none',
      displayStateFour: 'none',
      displayStateFive: 'none',
      showInfo: '',
      updatePercent: 0,
      updateTitle: '检测更新',
      flagOne: 0,
      flagTwo: 0,
      updateType: 0,
      disable: false,
      updateNow: false,
      lockScreen: false,
      childRoute: [],
      search: '',
      curMenu: '',
      showOptions: false,
      showSearchPanel: false,
      unlockUser: {
        username: '',
        password: '',
        errInfo: '123',
      },
      tenantData: {
        tenantId: '',
        tenantName: '',
      },
      submitFlag: false,
      submitDisabled: false,
      // 数据格式同左侧导航栏菜单格式
      options: [],
      showSystem: false, // 是否显示全部子系统
      dragItemIndex: -1, // 菜单拖动项index
      isShowMsg: false,
      drag: false,
      isDragEnded: false,
      dragData: {},
      showMenuSearch: true,
      localLangs: [],
      isShowSpace: false,
      curSpaceId: curSpaceId,
      curSpaceName: curSpaceName,
      setSpaceModel: false,
      isWebType: false,
      spaceData: [],
      spaceNode: [],
      showSysLen: 0,
    }
  },
  components: {
    draggable, // 菜单拖动
    HSearchselect,
    LockScreen,
    Headerbar
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'activeIndex',
      'visitedViews',
      'searchRoute',
      'hasOpened',
      'leafTotal',
      'clickItemIndex',
      'systemHeight',
    ]),
    menusRoot: {
      get () {
        return this.$store.state.app.menusRoot
      },
      set (value) {
        this.$store.state.app.menusRoot = value
      },
    },
    logoStyle () {
      return {
        background: `url(./static/logo/logo-t.png) center center no-repeat`
      }
    },
    systemLangs () {
      return this.langs.filter((it) => this.localLangs.indexOf(it.lang) !== -1)
    },
    userImage () {
      return this.$store.state.user.userImage
    }
  },
  watch: {
    theme () {
      allToggleClass(document.getElementsByTagName('html')[0], this.theme)
    },
    isDragEnded (val) {
      let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
      if (val) {
        let obj = this.dragData
        // 超出区域不提交数据
        if (
          !obj.hasOwnProperty('placeMenuCode') &&
          !obj.hasOwnProperty('placeKindCode')
        ) {
          this.isDragEnded = false
          return
        }
        let dropurl = '/dragAndDropMenu' + '?time=' + new Date().getTime()
        if (isUrlLowercase === 'true') {
          dropurl = dropurl.toLowerCase()
        }
      }
    },
    '$route': {
      immediate: true,
      handler (route) {
        const { path, fullPath } = route
        if (path !== '/ctl-index' || fullPath !== '/ctl-index') {
          this.$bus.$emit('hiddenMarket', false)
        }
        this.menuActive = this.menusRoot.findIndex(v => v.url === route.path)
      }
    }
  },
  methods: {
    ejectPayPwd () {
      this.handleResetPass()
      this.pwTypeChange('payPwd')
    },
    changeLocale (locale) {
      this.$i18n.locale = locale
      localStorage.setItem('lang', locale)
      Cookies.set('lang', locale)
      let langUrl = '/languageChange' + '?time=' + new Date().getTime()
      if (window.LOCAL_CONFIG.isUrlLowercase + '' === 'true') {
        langUrl = langUrl.toLowerCase()
      }
      this.$http
        .post(window.LOCAL_CONFIG.OMC_GSV + langUrl, { lang: locale })
        .then((res) => {
          if (res && res.data) {
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    setNodeSelected (arr, id) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          this.$set(arr[i], 'selected', true)
          return
        } else {
          if (arr[i] && arr[i].children && arr[i].children.length > 0) {
            this.setNodeSelected(arr[i].children, id)
          }
        }
      }
    },
    onEnd (str) {
      let placeNodeInx = this.menusRoot.findIndex(
        (item) => item.kind_code === this.dragData.placeKindCode
      )
      if (this.dragData.draggedIndex > placeNodeInx) {
        this.dragData.action = '1'
      }
      this.isDragEnded = true
    },
    // 子系统排序
    onMove ({ relatedContext, draggedContext }) {
      this.dragData = {
        draggedIndex: draggedContext.futureIndex,
        menuCode: draggedContext.element.id,
        kindCode: draggedContext.element.kind_code,
        placeMenuCode: relatedContext.element.id,
        placeKindCode: relatedContext.element.kind_code,
        action: '0',
      }
    },
    onSelectMenu (option) {
      this.search = ''
      // this.$refs.select.setQuery('')
      this.$nextTick(() => {
        setTimeout(() => {
          this.$router.push(option.url)
        }, 300)
      })
    },
    // 显示子系统排序框
    showSystemList () {
      this.showSystem = true
    },
    hideSystemList () {
      this.showSystem = false
    },
    // 鼠标经过菜单显示隐藏可拖动按钮
    showDragColl (index) {
      this.dragItemIndex = index
    },
    hideDragColl () {
      this.dragItemIndex = -1
    },
    // 修改个人信息
    handleChangePersonInfo () {
      let me = this
      me.$router.push({ path: '/accountCore' })
    },
    userFormReset () {
      this.$refs.setUserModi.resetFields()
      this.handleChangePersonInfo()
    },
    closeUserForm () {
      this.changePerspnInfo = false
    },
    // 换肤
    handleChangeTheme (color) {
      this.theme = color
      Cookies.set('theme', color)
    },
    handleResetPass () {
      this.tipState = ''
    },
    handleResetForm (name) {
      this.$refs[name].resetFields()
    },
    handleSetPassword () {

    },
    // 注销
    logoff () {
      if (this.$myIpcSend.isWebType()) {
        this.$hMsgBox.confirm({
          width: 20,
          height: 30,
          title: '交易系统',
          content: '<p>确认注销登录?</p>',
          onOk: () => {
            let param = { 'text': '确认注销登录?', 'type': 0 }
            this.$store.dispatch('Logout', param).then((res) => {
              if (res === 0) {
                this.$localStore.set('reload', true)
                this.$myIpcSend.ipcSender(this.$router, 'login', '', '/login')
              } else {
                this.$hMsgBox.info({
                  width: 20,
                  height: 30,
                  title: '交易系统',
                  content: '<p>注销登录失败</p>'
                })
              }
            }).catch(err => {
              console.error(err)
            })
          },
          onCancel: () => {
            // this.$hMessage.info('点击了取消')
          }
        })
      } else {
        let param = { 'text': '确认注销登录?', 'type': 1 }
        this.$store.dispatch('Logout', param).then(() => {
          this.$localStore.set('reload', true)
          this.$myIpcSend.ipcSender(this.$router, 'login', 'logoff')
          this.$myIpcSend.renderer().removeAllListeners()
        }).catch(err => {
          console.error(err)
        })
      }
    },
    // 退出
    logout (data = 0, data1 = 0) {
      // 判断是否为IAR单点登录，如果是调用casLogout
      let isIARCasLogin = window.LOCAL_CONFIG.isIARCasLogin + ''
      let isCasAdapter = window.LOCAL_CONFIG.isCasAdapter + ''
      if (isIARCasLogin === 'true') {
        this.$store.dispatch('casLogout').then(() => {
          if (isCasAdapter !== 'true') {
            // 非适配器时需要刷新页面重新加载，适配器时通过cas登出后的重定向回跳到首页
            location.reload()
          }
        })
      } else {
        if (this.$myIpcSend.isWebType()) {
          this.$hMsgBox.confirm({
            width: 20,
            height: 30,
            title: '交易系统',
            content: '<p>确认退出系统?</p>',
            onOk: () => {
              let param = { 'text': '确认退出系统?', 'type': 0 }
              this.$store.dispatch('Logout', param).then((res) => {
                if (res === 0) {
                  this.$myIpcSend.ipcSender(this.$router, 'logout', '', '/login?logout=true')
                } else {
                  this.$hMsgBox.info({
                    width: 20,
                    height: 30,
                    title: '交易系统',
                    content: '<p>退出系统失败</p>'
                  })
                }
              }).catch(err => {
                console.error(err)
              })
            },
            onCancel: () => {
              // this.$hMessage.info('点击了取消')
            }
          })
        } else {
          let param = { 'text': '确认退出系统?', 'type': 1 }
          // 自动更新导致退出，使用type==0
          if (data === 1) {
            param = { 'text': '确认退出系统?', 'type': 0 }
          }
          this.$store.dispatch('Logout', param).then((res) => {
            if (res === 0) {
              this.$myIpcSend.ipcSender(this.$router, 'logout', data1)
            }
          }).catch(err => {
            console.error(err)
          })
        }
      }
    },
    // 显示检测更新对话框
    startUpdate () {
      if (this.updateNow) {
        // 开始安装
        this.showInfo = '正在安装...'
        this.disable = true
        this.displayStateThree = 'none'
        this.$myIpcSend.ipcSender(this.$router, 'isUpdateNow', this.updateType)
      } else {
        this.displayStateThree = 'inline' // 显示进度条
        this.showInfo = '正在下载'
        this.updatePercent = 0
        this.disable = true
        if (this.updateType === 3) {
          // 全量更新
          this.$myIpcSend.ipcSender(this.$router, 'isDownloadNow')
        } else {
          // 增量更新
          this.$myIpcSend.ipcSender(this.$router, 'isIncrement', 'mainWindow')
        }
      }
    },
    // 关闭检测更新对话框
    closeUpdate () {
      this.showProgressInfo = false
      this.updateNow = false
      this.flagOne = 2
      this.flagTwo = 0
    },
    activeSidebar (index, option) {
      this.$router.push(option.url || option.redirect)
    },
    onkeypress () { },
    // 验证密码强度
    validatePwd (s) { },
    bitCount (i) {
      let count = 0
      while (i) {
        ++count
        i &= i - 1
      }
      return count
    },
    ok () {
      this.msgInfo = ''
      this.closable = false
    },
    cancel () { },
    compileFlatState (data, leafData, id) {
      function flattenChildren (node, leafData) {
        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => flattenChildren(child, leafData))
        } else {
          node.search_id = id
          leafData.push(node)
        }
      }
      flattenChildren(data, leafData)
      return leafData
    },
    handleLeafData (index) {
      let child = []
      let leafData = []
      let isMergeMenu = window.LOCAL_CONFIG.isMergeMenu + ''
      // isMergeMenu为true时合并菜单
      child =
        isMergeMenu === 'true'
          ? this.menusRoot
          : this.menusRoot[index] === null
            ? null
            : this.menusRoot[index].children
      if (child && child.length > 0) {
        child.forEach((item, index) => {
          if (item && item.children && item.children.length > 0) {
            this.compileFlatState(item, leafData, item.id)
          }
        })
      }
      this.$store.dispatch('initLeafTotal', leafData)
      this.options = leafData
    },
    handleResize () {
      this.$nextTick(() => {
        if (this.$refs.systemItem) {
          this.$store.dispatch(
            'changeSystemHeight',
            this.$refs.systemItem.offsetHeight
          )
          let showSysWidth = document.getElementsByClassName('h-system-list')[0]
            .offsetWidth
          let subSys = document.getElementsByClassName('h-topbar-subMenu')
          let width = 0
          for (let i = 0; i < subSys.length; i++) {
            width += subSys[i].offsetWidth
            if (width < showSysWidth) {
              this.showSysLen = i + 1
            }
          }
        }
      })
    },
    // 获取多租户
    handleTenant () { },
    // 获取数据字典
    handleDicts () { },
    // 查询系统参数，获取锁屏时间
    handleSysParams () { },
    // 查询系统参数，获取密码验证登记
    handlePwdCheckStandard () { },
    // 校验密码是否过期
    handleCheckPwdExpired () { },

    // 检查当前登录用户密码是否为初始化密码，是则必须修改密码方可进入系统
    handleCheckDefPwd () { },
    send (key, val) {
      this.$bus.$emit(key, val)
    },
    received (keys) {
      if (!Array.isArray(keys)) {
        keys = [keys]
      }
      for (const key of keys) {
        this.$bus.$on(key, (val) => {
          let methods = this.$options.methods
          if (methods[key]) {
            methods[key].call(this, val)
          }
        })
      }
    },
    handlefocus (param) {

    },
    handleblur (param) {

    },
    /**
     * 获取用户头像
    **/
    getUserImage () {
      getHeadImg({}).then(res => {
        if (res.data.success) {
          if (res.data.headImg && res.data.headImg != '') {
            let imgUrl = window.LOCAL_CONFIG.API_HOME + '/' + res.data.headImg
            this.$store.dispatch('setUserImage', imgUrl)
          }
        }
      }).catch(e => {
        console.log(e)
        this.$hMessage.error('网络通信失败,服务器异常')
      })
    }
  },
  created () {
    this.isShowMsg = window.LOCAL_CONFIG.isShowMsg
    this.isShowLocalLang = window.LOCAL_CONFIG.isShowLocalLang
    this.isShowTheme = window.LOCAL_CONFIG.isShowTheme
    this.localLangs = window.LOCAL_CONFIG.localLangs
    this.isShowSpace = window.LOCAL_CONFIG.isOpenSpace
    // 根据系统参数配置
    let isMergeMenu = window.LOCAL_CONFIG.isMergeMenu + ''
    let isOpenFirstPwd = window.LOCAL_CONFIG.isOpenFirstPwd + ''
    let isHidePwdAndLockScreen =
      window.LOCAL_CONFIG.isHidePwdAndLockScreen + ''
    let isTenantMode = window.LOCAL_CONFIG.isTenantMode + ''
    let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
    let freeLogin = window.LOCAL_CONFIG.freeLogin + ''
    let showMenuSearch = window.LOCAL_CONFIG.showMenuSearch + ''
    // 菜单叶子节点生成下拉数据
    this.handleLeafData(this.activeIndex)
    // 检查有无用户信息，若无用户信息表示重新进入页面，此时需要重新获取用户信息
    if (
      window.sessionStorage.getItem('currUserId') &&
      window.sessionStorage.getItem('currUserId') != 'undefined' &&
      window.sessionStorage.getItem('nickName') &&
      window.sessionStorage.getItem('nickName') != 'undefined' &&
      window.sessionStorage.getItem('currUserId') ==
      Cookies.get('operator_code') &&
      window.sessionStorage.getItem('kindCode') &&
      window.sessionStorage.getItem('envId')
    ) {
    }
    // 是否合并菜单
    if (isMergeMenu === 'true') {
      this.isMergeMenu = true
    }
    // 是否第一次打开时弹出修改密码弹出框
    if (isOpenFirstPwd === 'true') {
      this.isOpenFirstPwd = true
    }
    // 是否隐藏锁屏按钮
    if (isHidePwdAndLockScreen === 'true') {
      this.isHidePwdAndLockScreen = true
    }
    // 免登录模式
    if (freeLogin === 'true') {
      this.freeLogin = true
    }
    // 是否显示顶部菜单检索框
    if (showMenuSearch === 'false') {
      this.showMenuSearch = false
    }
    // 是否是多租户模式(admin和系统不显示切换租户)
    if (
      isTenantMode === 'true' &&
      Cookies.get('operator_code') != 'admin' &&
      Cookies.get('tenantId') != ''
    ) {
      this.isShowTenant = true
    }
    // 查询系统参数，获取锁屏时间
    if (freeLogin == 'false' && isHidePwdAndLockScreen == 'false') {
      this.handleSysParams()
    }
    // 查询系统参数，获取密码验证登记
    if (
      freeLogin == 'false' &&
      (isOpenFirstPwd == 'true' || isHidePwdAndLockScreen == 'false')
    ) {
      this.handlePwdCheckStandard()
    }
    // 检查当前登录用户密码是否为初始化密码，是则必须修改密码方可进入系统
    if (
      freeLogin == 'false' &&
      (isOpenFirstPwd == 'true' || isHidePwdAndLockScreen == 'false')
    ) {
      this.handleCheckDefPwd()
    }
    // 检查密码是否过期
    if (
      freeLogin == 'false' &&
      (isOpenFirstPwd == 'true' || isHidePwdAndLockScreen == 'false')
    ) {
      this.handleCheckPwdExpired()
    }
    // 是否web端登录
    if (this.$myIpcSend.isWebType()) {
      this.isWebType = true
    }
    // 获取头像
    this.getUserImage()
  },
  mounted () {
    this.received('ejectPayPwd')
    this.handleResize()
    on(window, 'resize', this.handleResize)
    document.getElementsByTagName('html')[0].className = this.theme
    if (!this.$myIpcSend.isWebType()) {
      // 监听系统推出事件
      this.$myIpcSend.renderer().on('logout', (event, data) => {
        this.logout(data)
      })
      // 监听检测更新事件
      this.$myIpcSend.renderer().on('update', (event, data) => {
        if (this.flagOne === 2) {
          this.flagOne = 0
        }
        if (this.flagTwo === 0) {
          this.flagTwo = 1
        }
      })
      this.$myIpcSend.renderer().on('message', (event, text) => {
        if ((text.type === 3 || text.type === 5) && this.flagOne === 0) {
          this.flagOne = 1
          this.showProgressInfo = true
          this.displayStateTwo = 'inline'
          this.displayStateFive = 'inline'
          this.displayStateThree = 'none'
          this.updatePercent = 0
          this.updateType = text.type
          this.showInfo = `检测到新版本v${text.version}，是否下载更新？\n${text.detail}`
        } else if (text.type === 4 && this.flagTwo === 1) {
          this.flagTwo = 2
          this.showProgressInfo = true
          this.displayStateOne = 'inline'
          this.showInfo = '当前版本已经是最新版本！'
        }
      })
      this.$myIpcSend.renderer().on('isUpdateNow', (event, data) => {
        this.updateNow = true
      })
      this.$myIpcSend.renderer().on('updateProcess', (event, data) => {
        this.updatePercent = parseInt(data)
        if (this.updatePercent === 100) {
          this.disable = false
          this.showInfo = '下载完成，是否进行安装？'
        }
      })
      this.$myIpcSend.renderer().on('updateSuccess', (event, data) => {
        this.showInfo = '安装成功，重启后生效'
        this.logout(1, 1)
      })
    }
  },
  beforeDestroy () { // 在组件生命周期结束的时候销毁。
    clearInterval(this.timer)
    off(window, 'resize', this.handleResize)
    this.$bus.$off('ejectPayPwd')
  },
  activated () {
    this.handleResize()
    on(window, 'resize', this.handleResize)
  },
  deactivated () {
    off(window, 'resize', this.handleResize)
  },
  beforeCreate () {
    // 非IE下固定滚动条样式
    if (
      navigator.userAgent.indexOf('MSIE') >= 0 ||
      navigator.userAgent.indexOf('Trident') < 0
    ) {
      window.sessionStorage.setItem(
        'scrollbarWidth',
        window.LOCAL_CONFIG.TABLE_SCROLLBAR_WIDTH || 7
      )
    }
  },
}
</script>
